'use client';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import MaterialLink from './material-link';
import EventListing from './event-listing';
import { momentParse } from '../utils/time';
import { eventPath, eventSeriesPath } from '../utils/slugify';
import type { SeriesGroup } from '../utils/group-recent-series-events';

type Props = {
  group: SeriesGroup;
};

const SeriesGroupCard = ({ group }: Props) => {
  const { events, seriesId, seriesName } = group;
  const [nextEvent, ...remainingEvents] = events;

  return (
    <div>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h3" sx={{ fontSize: 18, mt: 0, mb: 0.5 }}>
          <MaterialLink href={eventSeriesPath(seriesId, seriesName)}>
            {seriesName}
          </MaterialLink>
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {events.length} new events added
        </Typography>
      </Box>

      <EventListing event={nextEvent} fullDate />

      {remainingEvents.length > 0 && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          <Box component="span" sx={{ fontWeight: 500 }}>Also added: </Box>
          {remainingEvents.map((event, index) => {
            const start = momentParse(event.startAt, event.timezone);
            return (
              <span key={event.id}>
                <MaterialLink href={eventPath(event.id, event.name)} color="text.secondary">
                  {start.format('ddd MMM D h:mm A')}
                </MaterialLink>
                {index < remainingEvents.length - 1 && ', '}
              </span>
            );
          })}
        </Typography>
      )}

      <Box sx={{ mt: 2 }}>
        <MaterialLink href={eventSeriesPath(seriesId, seriesName)} variant="body2">
          View all events in series <ArrowForwardIcon sx={{ fontSize: 14, verticalAlign: 'middle' }} />
        </MaterialLink>
      </Box>
    </div>
  );
};

export default SeriesGroupCard;
